import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class ModeService {

  constructor() { }
  private modeName;
  setMode(mode:string){
    this.modeName = mode;

  }
  getMode(){
    return this.modeName;

  }
}
